<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Suppression d'un élément</span>
      </v-card-title>
      <v-card-text>
        <p>Voulez-vous vraiment supprimer définitivement l'élément suivant :</p>
        <ul>
          <li>{{inventoryNumber}} : {{name}}</li>
        </ul>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog">Annuler</v-btn>
        <v-btn color="error" text @click="deleteElement">Supprimer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template> 
 
  
  <script>
import axios from "axios";
export default {
  props: ["dialog", "_id", "name", "inventoryNumber", 'closeDialog'],
  methods: {
    deleteElement: async function() {
      await axios({
        method: "DELETE",
        url: `${process.env.VUE_APP_API_URI}/elements/${this._id}`
      });
      this.$router.go("/elements");
    }
  }
};
</script>